import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

function Footer() {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleCategorie = (cat) => {
    navigate(`/catalogue?categorie=${encodeURIComponent(cat)}`, { replace: true });
    window.scrollTo(0, 0);
  };

  const categories = [
    { label: "Bateaux a Moteur", value: "Bateaux à Moteur" },
    { label: "Yachts de Luxe",   value: "Yachts de Luxe" },
    { label: "Equipement",       value: "Équipement" },
    { label: "Sports et Loisirs",value: "Sports et Loisirs" },
    { label: "Voiliers",         value: "Voiliers" },
  ];

  return (
    <footer style={{ backgroundColor: "white", borderTop: "4px solid #0d9488" }}>
      <div style={{
        maxWidth: "1200px",
        margin: "0 auto",
        padding: isMobile ? "30px 16px" : "50px 30px",
        display: "grid",
        gridTemplateColumns: isMobile ? "1fr 1fr" : "1.5fr 1fr 1fr 1fr",
        gap: isMobile ? "24px" : "50px",
      }}>

        {/* Brand — pleine largeur sur mobile */}
        <div style={{ gridColumn: isMobile ? "1 / -1" : "auto" }}>
          <h4 style={{ fontSize: "20px", fontWeight: "700", color: "#1f2937", marginBottom: "15px" }}>
            Marina<span style={{ color: "#0d9488" }}>DZ</span>
          </h4>
          <p style={{ color: "#6b7280", fontSize: "14px", lineHeight: "1.7" }}>
            La premiere plateforme maritime en Algerie. Decouvrez les meilleures annonces
            de bateaux, yachts et equipements nautiques.
          </p>
          <div style={{ display: "flex", gap: "12px", marginTop: "20px" }}>
            {[
             
              { label: "Twitter",   path: "M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z" },
              { label: "Instagram", path: "M16 8a6 6 0 00-12 0v0a6 6 0 0012 0z" },
            ].map((social) => (
              <a key={social.label} href="https://www.instagram.com/marinadz40?igsh=cXh1ODR5b2R5dTgw" aria-label={social.label} style={{
                width: "36px", height: "36px", borderRadius: "50%",
                backgroundColor: "#f0fdfa", display: "flex", alignItems: "center", justifyContent: "center"
              }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#0d9488" strokeWidth="2">
                  <path d={social.path} />
                </svg>
              </a>
            ))}
          </div>
        </div>

        {/* Navigation */}
        <div>
          <h4 style={{ fontSize: "16px", fontWeight: "600", color: "#1f2937", marginBottom: "20px" }}>
            Navigation
          </h4>
          <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
            {[
              { label: "Accueil",              to: "/" },
              { label: "Catalogue",            to: "/catalogue" },
              { label: "Exposants",            to: "/exposants" },
              { label: "RFQ - Demande de devis", to: "/rfq" },
              { label: "À propos",             to: "/a-propos" },
              { label: "Contact",              to: "/contact" },
              { label: "Devenir Exposant",     to: "/inscription" },
            ].map((item) => (
              <li key={item.label} style={{ marginBottom: "12px" }}>
                <Link to={item.to} style={{ color: "#6b7280", fontSize: "14px", textDecoration: "none" }}
                  onMouseEnter={(e) => (e.target.style.color = "#0d9488")}
                  onMouseLeave={(e) => (e.target.style.color = "#6b7280")}>
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Categories */}
        <div>
          <h4 style={{ fontSize: "16px", fontWeight: "600", color: "#1f2937", marginBottom: "20px" }}>
            Categories
          </h4>
          <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
            {categories.map((cat) => (
              <li key={cat.label} style={{ marginBottom: "12px" }}>
                <button
                  onClick={() => handleCategorie(cat.value)}
                  style={{
                    background: "none", border: "none", padding: 0, cursor: "pointer",
                    color: "#6b7280", fontSize: "14px", textAlign: "left"
                  }}
                  onMouseEnter={(e) => (e.target.style.color = "#0d9488")}
                  onMouseLeave={(e) => (e.target.style.color = "#6b7280")}
                >
                  {cat.label}
                </button>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact — pleine largeur sur mobile */}
        <div style={{ gridColumn: isMobile ? "1 / -1" : "auto" }}>
          <h4 style={{ fontSize: "16px", fontWeight: "600", color: "#1f2937", marginBottom: "20px" }}>
            Contact
          </h4>
          <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
            <li style={{ marginBottom: "12px", color: "#6b7280", fontSize: "14px" }}>+213 665 925 211</li>
            <li style={{ marginBottom: "12px", color: "#6b7280", fontSize: "14px" }}>contact.marinadz@gmail.com</li>
            <li style={{ marginBottom: "12px", color: "#6b7280", fontSize: "14px" }}>Oran , Algerie</li>
          </ul>
        </div>
      </div>

      {/* Copyright */}
      <div style={{ borderTop: "1px solid #e5e7eb", padding: "20px", textAlign: "center" }}>
        <p style={{ color: "#9ca3af", fontSize: "14px" }}>
          {"© 2026 MarinaDZ. Tous droits reserves. | "}
          <Link to="/a-propos" style={{ color: "#9ca3af", textDecoration: "none" }}>À propos</Link>
          {" | "}
          <Link to="/contact" style={{ color: "#9ca3af", textDecoration: "none" }}>Contact</Link>
          {" | "}
        </p>
      </div>
    </footer>
  );
}

export default Footer;